<template>
  <div class="flex items-center gap-4">

    <!-- Profile Dropdown -->
    <div class="dropdown dropdown-end min-w-[200px]">
      <div tabindex="0" role="button"
           class="flex items-center gap-3 bg-surface-light px-4 py-2 rounded-lg hover:bg-neutral-100">
        <FallbackImg :src="resolveImage" class="w-10 h-10 rounded-full object-cover" :fallback="defaultImage"
             :alt="name"/>
        <div class="flex flex-col">
          <span class="text-primary font-semibold text-sm leading-tight">{{name}}</span>
          <span class="text-light text-xs leading-tight">{{role}}</span>
        </div>
        <i class="bi bi-chevron-down text-light text-xs ms-auto ps-2"/>
      </div>

      <div
          tabindex="0"
          class="dropdown-content mt-2 w-full bg-base-100 rounded-lg shadow-lg p-2 z-[1] text-neutral-500"
      >
        <button
            @click="$emit('editProfile')"
            class="flex gap-2 items-center px-4 py-2 hover:text-base-content text-sm w-full border-b last:border-b-0">
          <i class="bi bi-person-circle text-lg"></i>
          Edit profile
        </button>
        <button
            @click="$emit('logout')"
            class="flex gap-2 items-center px-4 py-2 hover:text-base-content text-sm w-full"
        >
          <i class="bi bi-box-arrow-right text-lg"></i>
          Log out
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import FallbackImg from "@/components/atoms/FallbackImg.vue";

const defaultImage = '/img/users/default.jpg'
const props = defineProps({
  id: {
    type: Number,
    default: 'Unknown ID'
  },
  name: {
    type: String,
    default: 'Unknown User'
  },
  role: {
    type: String,
    default: 'User'
  },
  image: {
    type: String,
    default: defaultImage
  },
  notifications: {
    type: Boolean,
    default: false
  }
});
const resolveImage = computed(() => {
  return new URL(props.image || defaultImage, import.meta.url).href;
})

const emit = defineEmits(["logout", "editProfile"]);
</script>